import React, {useEffect, useState} from "react";
import DataTable from "../../../components/data-table";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import Button from "../../../components/button";
import Modal from "../../../components/modal";
import Input from "../../../components/input";
import LoadingSpinner from '../../../components/loading-spinner';

import {
    clear_bank_account, 
    create_bank_account, 
    delete_bank_account, 
    get_all_bank_account, 
    update_bank_account, 
    CREATE_BANK_ACCOUNT, 
    UPDATE_BANK_ACCOUNT,
    DELETE_BANK_ACCOUNT, 
} from "../../../redux/bank_accounts";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const BankAccounts = (props) => {
    let history = useHistory();
    let dispatch = useDispatch();

    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const _get_all_bank_account = useSelector((state) => state.bank_account_module._get_all_bank_account);
    const _create_bank_account = useSelector((state) => state.bank_account_module._create_bank_account);
    const _update_bank_account = useSelector((state) => state.bank_account_module._update_bank_account);
    const _delete_bank_account = useSelector((state) => state.bank_account_module._delete_bank_account);
    const [data, setData] = useState([]);

    useEffect(() => {
        if (_get_all_bank_account.data.datos) {
            setData(_get_all_bank_account.data.datos);
        }
    }, [_get_all_bank_account]);

    const [permisos, setPermisos] = useState([]);
    const [actions, setActions] = useState([]);
    const [modal, setModal] = useState(false);
    const [modal_delete, setModalDelete] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [id, setId] = useState(0);

    const [form, setForm] = useState({
        identificacion: "",
        nombre_banco: "",
        tipo_cuenta: "",
        numero_cuenta: "",
        correo: "",
    });

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);

        }
    }, [props]);

    useEffect(() => {
        let act = []
        if (permisos) {
            if (permisos.filter(x => x.codigo === 'change_bankaccounts').length > 0) {
                act.push({
                    name: "edit",
                    label: "Edit",
                    icon: "bx bx-edit",
                    color: "primary",
                    onClick: (item) => {
                        setModal(true);
                        setId(item.id);
                        setForm({
                            ...form, 
                            identificacion: item.identificacion, 
                            nombre_banco: item.nombre_banco,
                            tipo_cuenta: item.tipo_cuenta,
                            numero_cuenta: item.numero_cuenta,
                            correo: item.correo,
                        });
                    },
                })

            }
            if (permisos.filter(x => x.codigo === 'delete_bankaccounts').length > 0) {
                act.push({
                    name: "delete",
                    label: "Eliminar",
                    icon: "bx bxs-trash",
                    color: "danger",
                    onClick: (item) => {
                        setModalDelete(true);
                        setId(item.id)
                    },
                })

            }
        }
        setActions(act);
    // eslint-disable-next-line
    }, [permisos, history]);

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    useEffect(() => {
        if (_create_bank_account.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_bank_account(CREATE_BANK_ACCOUNT));
            dispatch(get_all_bank_account(token));
            setIsLoading(false);
            setModal(false);
        } else if (_create_bank_account.status !== 0) {
            dispatch(clear_bank_account(CREATE_BANK_ACCOUNT));
            toast.error(_create_bank_account.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_create_bank_account, dispatch, history, token, id]);

    useEffect(() => {
        if (_update_bank_account.status === 200) {
            toast.success("Actualizado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_bank_account(UPDATE_BANK_ACCOUNT));
            dispatch(get_all_bank_account(token));
            setIsLoading(false);
            setModal(false);
            setId(0);
        } else if (_update_bank_account.status !== 0) {
            dispatch(clear_bank_account(UPDATE_BANK_ACCOUNT));
            toast.error(_update_bank_account.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_update_bank_account, dispatch, history, token, id]);

    useEffect(() => {
        if (_delete_bank_account.status === 200) {
            toast.success("Eliminado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_bank_account(DELETE_BANK_ACCOUNT));
            dispatch(get_all_bank_account(token));
            setModalDelete(false);
            setId(0);
        } else if (_delete_bank_account.status !== 0) {
            dispatch(clear_bank_account(DELETE_BANK_ACCOUNT));
            toast.error(_delete_bank_account.message);
        }
    }, [_delete_bank_account, history, token, dispatch]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (form.identificacion === "") {
            toast.error("Debe ingresar una identificación", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.nombre_banco === "") {
            toast.error("Debe ingresar el nombre del banco", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.tipo_cuenta === "") {
            toast.error("Debe ingresar el tipo de cuenta", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.numero_cuenta === "") {
            toast.error("Debe ingresar el número de cuenta", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.correo === "") {
            toast.error("Debe ingresar el correo electrónico", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (id === 0) {
            dispatch(create_bank_account(token, form));
        } else {
            dispatch(update_bank_account(token, id, form));
        }
    };

    const handleDelete = () => {
        dispatch(delete_bank_account(token, id));
    };

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Lista"
                            items={[{label: "Cuentas bancarias", link: "/cuentas"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div><ToastContainer/></div>
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                {
                                    permisos.filter(x => x.codigo === 'add_bankaccounts').length > 0 ? 
                                    <Button type="button" text="Crear" theme="calendar" onClick={() => {
                                        setModal(true); 
                                        setForm({...form, identificacion: '', nombres: ''}); 
                                        setId(0);
                                    }}/> : null
                                }
                                <div className="table-responsive">
                                    <DataTable
                                        dataTable={data}
                                        columns={[
                                            {
                                                name: "nombre_banco",
                                                label: "Banco",
                                                type: "text",
                                            },
                                            {
                                                name: "identificacion",
                                                label: "Identificación",
                                                type: "text",
                                            },
                                            {
                                                name: "tipo_cuenta",
                                                label: "Tipo cuenta",
                                                type: "text",
                                            },
                                            {
                                                name: "numero_cuenta",
                                                label: "Número cuenta",
                                                type: "text",
                                            },
                                            {
                                                name: "correo",
                                                label: "Correo",
                                                type: "text",
                                            },
                                            {
                                                name: "activo",
                                                label: "Activo",
                                                type: "boolean",
                                            },
                                        ]}
                                        actions={actions}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modal}>
                <form onSubmit={handleSubmit}>
                    {isLoading && <LoadingSpinner/>}
                    <div className="card-body">
                        <h5 className="titulo_modal type_text mb-2">{id === 0 ? 'Crear ' : 'Editar ' } cuenta bancaria</h5>
                        <div className="form-group">
                            <Input
                                label="Identificación"
                                name="identificacion"
                                value={form.identificacion}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <Input
                                label="Nombre de banco"
                                name="nombre_banco"
                                value={form.nombre_banco}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <Input
                                label="Tipo de cuenta"
                                name="tipo_cuenta"
                                value={form.tipo_cuenta}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <Input
                                label="Número de cuenta"
                                name="numero_cuenta"
                                value={form.numero_cuenta}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <Input
                                label="Correo electrónico"
                                name="correo"
                                value={form.correo}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button onClick={() => {}} className={`btn btn-calendar mb-1 button_div`}>Guardar</button>
                        <button type="button" onClick={() => {setModal(false);}} className={`btn btn-outline-calendar button_div`}>Cancelar</button>
                    </div>
                </form>
            </Modal>
            <Modal className="modal-main div-modal" show={modal_delete}>
                <div className="modal-content">
                    <div className="card-body text-center">
                        <h5>¿Está seguro de eliminar o inactivar el registro?</h5>
                    </div>
                    <div className="card-footer text-center">
                        <button type="button" className="btn btn-calendar mb-1 button_div" onClick={() => {handleDelete()}}>
                            SI
                        </button>
                        <button type="button" className="btn btn-outline-calendar button_div" onClick={() => {setModalDelete(false)}}>
                            NO
                        </button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default BankAccounts;
